module.exports = __webpack_public_path__ + "static/media/APA_H_LOGO.f3531b35.png";